import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("vpw_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && window.location.pathname.startsWith("/admin") &&
        !window.location.pathname.includes("/admin/login")) {
      localStorage.removeItem("vpw_token");
      window.location.href = "/admin/login";
    }
    return Promise.reject(err);
  }
);

export const fileUrl = (id) => {
  const token = localStorage.getItem("vpw_token");
  return `${API}/files/${id}${token ? `?auth=${token}` : ""}`;
};

// Resolve an image reference: local /gallery path, http url, or uploaded file id
export const resolveImage = (ref) => {
  if (!ref) return "";
  if (ref.startsWith("http") || ref.startsWith("/")) return ref;
  return `${API}/files/${ref}`;
};

export const setToken = (t) => localStorage.setItem("vpw_token", t);
export const getToken = () => localStorage.getItem("vpw_token");
export const clearToken = () => localStorage.removeItem("vpw_token");
